import { OPERATIONS_HISTORY_KEY } from '@/shared/config';
import { useQueryClient } from '@tanstack/react-query';
import { syncActiveOperationsDeltas } from '../lib/operationsDeltaSync';

type Props = {
  userId?: string;
};

export const useOperationsRefetch = ({ userId }: Props) => {
  const queryClient = useQueryClient();

  const refetchAll = () => {
    void syncActiveOperationsDeltas(queryClient, userId).catch(() => {
      queryClient.invalidateQueries({
        queryKey: [OPERATIONS_HISTORY_KEY, userId],
        exact: false,
      });
    });
  };

  return { refetchAll };
};
